// extracted by mini-css-extract-plugin
export default {"headerContainer":"NoSectionsStackItems_headerContainer__Ihi1r","augustRevisionSectionContainer":"NoSectionsStackItems_augustRevisionSectionContainer__vS1MV"};